import { Outlet } from "react-router-dom";

import { useFeatureEnabled } from "@/lib/features";
import { FeatureUnavailable } from "./FeatureUnavailable";

/** Gates a route (or subtree, via Outlet) behind Feature Toggle Management.
 * Combine with RequirePermission for a module that needs both (most do) -
 * order doesn't matter, both must pass.
 *
 * This is UX polish, not the security boundary: the backend's
 * middleware.RequireFeature is what actually 403s a disabled module's API,
 * and it fails closed on a still-loading/unknown key where this fails open
 * (see useFeatureEnabled) - so the worst this component can do wrong is show
 * a page briefly before its own API calls 403 anyway, never grant real
 * access. */
export function RequireFeature({ feature }: { feature: string }) {
  const enabled = useFeatureEnabled(feature);
  if (!enabled) return <FeatureUnavailable />;
  return <Outlet />;
}
